import React , {useState} from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

function MerDropDown(props) {
  const [value, setValue] = useState(props.info.value);

  return (
    <FormControl 
    sx={{maxWidth:'75%',marginBottom:2,marginTop:2, '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'black',
      },
  }}} size="small">
      <InputLabel required={props.info.mandatory} sx={{color:'black' , 
        '& .MuiFormLabel-asterisk': {
          color: 'red', fontSize: '30px'
        },
      }}>{props.info.question_text}</InputLabel>
      <Select
        value={value}
        label={props.info.question_text}
        disabled={!props.abled}
        variant='outlined'
        onChange={(e) => {
          setValue(e.target.value);
          props.handleChange(props.info.id,e.target.value,props.info?._id);
      }}
      >
      {props.info.options.map((option , index)=>{
          return(
            <MenuItem key={index} value={option}>{option}</MenuItem>
          );
      })}
      </Select>
    </FormControl>
  )
}

export default MerDropDown
